define('lib/collection/ServerPaginatedCollection',['require','lib/collection/BaseCollection','lib/pager/Pager'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var Pager = require('lib/pager/Pager');

    return BaseCollection.extend({

        _pager: null,

        initialize: function (options) {
            if (options && options.pager) {
                this._pager = options.pager;
            } else {
                this._pager = new Pager();
            }
            this.listenTo(this._pager, 'change', this.onPagerChanged);

            BaseCollection.prototype.initialize.apply(this, arguments);
        },

        onPagerChanged: function () {
            this._loaded = false;
            this.load({
                data: this._pager.getData()
            })
        },

        getPager: function () {
            return this._pager;
        },

        parse: function (resp) {
            this._pager.setState(resp.metadata.page, resp.metadata.pages_count, resp.metadata.items_count);

            return resp.data;
        }

    });
});
